import { API_PREFIX } from '@/util/axios'

export default {
  common: {
    upload: '/'
  },
  sso: {
    login: '/sso/login-url',
    logout: '/sso/logout-url',
    checkTicket: '/sso/check-ticket',
    checkCode: '/sso/check-code'
  },
  moduleA: {
    // GET
    list: '/module-a/list'
  },
  mall: {
    login: API_PREFIX + '/sso/login',
    logout: API_PREFIX + '/sso/logout',
    checkCode: API_PREFIX + '/sso/checkCode',
    menus: API_PREFIX + '/functionMenu/queryAll',
    on: true
  },
  taotieFlag:false,//ture为正式环境
}



// WEBPACK FOOTER //
// ./src/config/api.js